export const tomos = [
  {
    number: 1,
    title: 'Force fondamentale & stabilité',
    sessions: '61 séances',
    months: 'Mois 1 et 2',
    desc: 'Pour construire des bases solides et une force structurelle chez vos adhérents dès le premier jour.',
    details: [
      'Schémas de base\u00a0: squat, charnière, poussée, tirage et gainage',
      'Progressions techniques semaine après semaine pour corriger la posture',
      'Idéal pour démarrer l’année ou accueillir de nouveaux adhérents',
    ],
    bar: 'bg-orange-500',
    text: 'text-orange-400',
    border: 'border-t-orange-500',
  },
  {
    number: 2,
    title: 'Puissance & transfert fonctionnel',
    sessions: '61 séances',
    months: 'Mois 3 et 4',
    desc: 'Pour développer vitesse, explosivité et transfert direct vers le geste sportif.',
    details: [
      'Sauts, lancers et pliométrie sécurisée par niveaux',
      'Complexes force-puissance avec kettlebells et medecine ball',
      'Transfert vers le geste sportif et les mouvements du quotidien',
    ],
    bar: 'bg-blue-500',
    text: 'text-blue-400',
    border: 'border-t-blue-500',
  },
  {
    number: 3,
    title: 'Endurance métabolique & perte de masse grasse',
    sessions: '61 séances',
    months: 'Mois 5 et 6',
    desc: 'Pour brûler les graisses et pousser le conditionnement métabolique de votre groupe au maximum.',
    details: [
      'Formats EMOM, AMRAP, Tabata et intervalles déjà programmés',
      'Intensité maîtrisée avec versions A/B/C pour chaque niveau',
      'Cours à forte dépense avec temps de travail et de repos définis',
    ],
    bar: 'bg-red-500',
    text: 'text-red-400',
    border: 'border-t-red-500',
  },
  {
    number: 4,
    title: 'Hypertrophie fonctionnelle',
    sessions: '61 séances',
    months: 'Mois 7 et 8',
    desc: 'Pour gagner du muscle de façon fonctionnelle grâce à des protocoles d’hypertrophie adaptés.',
    details: [
      'Blocs de volume et de tension avec du matériel de base',
      'Supersets et tempos pensés pour les cours collectifs',
      'Équilibre entre esthétique, force et performance',
    ],
    bar: 'bg-violet-500',
    text: 'text-violet-400',
    border: 'border-t-violet-500',
  },
  {
    number: 5,
    title: 'Agilité & performance athlétique',
    sessions: '61 séances',
    months: 'Mois 9 et 10',
    desc: 'Pour améliorer coordination, agilité et capacités athlétiques, quel que soit le niveau.',
    details: [
      'Échelles, plots, changements de direction et réactivité',
      'Coordination et équilibre avec une progression graduelle',
      'Jeux et défis qui gardent le groupe motivé',
    ],
    bar: 'bg-emerald-500',
    text: 'text-emerald-400',
    border: 'border-t-emerald-500',
  },
  {
    number: 6,
    title: 'Spécialisation & défis finaux',
    sessions: '60 séances',
    months: 'Mois 11 et 12',
    desc: 'Pour mettre à l’épreuve tout ce qui a été travaillé dans l’année avec des défis et benchmarks.',
    details: [
      'Benchmarks pour mesurer la progression de vos adhérents',
      'Défis par équipes et entraînements de fin d’année',
      'Évaluations pour comparer le début et la fin de l’année',
    ],
    bar: 'bg-amber-500',
    text: 'text-amber-400',
    border: 'border-t-amber-500',
  },
]

export const sessionFeatures = [
  { title: 'Objectif du jour', desc: 'Pour savoir exactement où vous allez' },
  { title: 'Échauffement prêt', desc: 'Plus besoin d’improviser' },
  { title: '3 versions\u00a0: A/B/C', desc: 'Groupe mixte ou séparé, ça marche pareil' },
  { title: 'Séries, reps et temps', desc: 'Tout est précisé — rien d’ambigu' },
  { title: 'Retour au calme pro', desc: 'Chaque cours se termine avec structure' },
  { title: 'Le conseil du coach', desc: 'Débutant, vous apprenez. Pro, vous validez' },
  { title: 'Une séance par page', desc: 'Vous ouvrez, vous coachez, c’est tout' },
]

export const featureChips = [
  'Salle + Box + Fonctionnel',
  'Programme annuel prêt',
  'Versions A/B/C par niveau',
  'Échauffements et retours au calme',
  '365 séances prêtes',
  'Matériel de base',
]
